<template>
  <v-container class="login-container">

    <template v-if="products.length > 0">

      <div class="container">

        <div class="card" v-for="item in products" :key="item.id" >
          <!-- <div class="box" style=" background-image: url(https://img.danawa.com/prod_img/500000/161/711/img/4711161_1.jpg?shrink=330:330&_v=20161130143749);background-repeat: no-repeat;"> -->
            <div class="box" style="background-image: url('https://img.danawa.com/prod_img/500000/161/711/img/4711161_1.jpg?shrink=330:330&_v=20161130143749'); background-repeat: no-repeat;">
            <div class="content">
              <!-- <h2>01</h2> -->
              <h3>{{item.name}}</h3>
              <p>{{item.descript}}</p>
              <a @click="addCard(item)">Cart(+)</a>
            </div>
          </div>
        </div> 

      </div>

        <!-- 
        <div class="item-wrapper justify-center">
          <router-link  class="notice-list " v-for="item in list" :key="item.cid"  :to="`/config/news/${item.cid}`"  >
            <div class="notice-info">
              <div class="notice-category">[ <span>{{item.title_sub}}</span> ]</div>
              <div class="notice-title">{{item.title}}</div>
              <div class="notice-list_newimg"></div>
            </div>
            <div class="notice-date">{{ $moment(item.created_at).format('YYYY-MM-DD')}}</div>
          </router-link >
        </div> -->

    </template>

    
 
    <v-dialog v-model="confirmModal" persistent max-width="30rem">
      <v-card>
        <v-card-title>바코드를 스캔해주세요.</v-card-title>
       
        <div class="qr-g" style="margin :30px;">
          <v-fade-transition leave-absolute >
            <vue-q-r-code-component                                                                 
                    :size="200"
                    :text="jsonDataTxt"
                    class="qr-code"                  
                  />
          </v-fade-transition>
        </div>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-btn
            color="#AFAFAF"
            width="98%"
            padding="20px"
            text
            x-large
            class="font-weight-bold"
            @click="confirmModal = false"
          >
            {{ $t('send.confirmModal.cancel') }}
          </v-btn>
        
          <!-- <v-btn
            color="error"
            width="48%"
            text
            x-large
            class="font-weight-bold"
            @click="authCheck"
          >
            Payed
          
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    
    <v-bottom-sheet v-model="confirmDialog" scrollable>
      <v-card class="rounded-lg" style="min-height: 50vh;">
        <v-card-title></v-card-title>
        <v-card-text class="type-wrapper" >
          <div class="sheet-title">구매내역</div>
          
        <!-- 
          <div class="sheet-row">
            <span>From.</span>
            <span></span>
          </div> 
        -->
          
          <v-divider class="my-5"></v-divider>
        <!-- 
          <div class="sheet-row">
            <span>스왑 경로</span>
            <div class="d-flex align-center">
              <div class="d-flex align-center">
                
              </div>
              <img
                style="width:0.7rem;margin:0 1rem;"
                :src="require(`@/assets/icon/double-arrow.svg`)"
              />
              <div class="d-flex align-center">
                <div class="logo-circle">
                  <img
                    style="width:0.8rem;"
                    srca="require(`@/assets/svg/ccc-logo.svg`)" 
                  />
                </div> 
                sssssss
              </div>
            </div>
          </div>
        -->
          <template v-if="(this.cartList.length > 0) ">
            <v-card-text class="type-wrapper" >
              
              <div class="sheet-row cart-item" style="width:100%" v-for="cart in cartList" :key="cart.id" > 
                  <span > * {{cart.name}}</span>
                  <!-- <span > 개수 : 1 </span> -->
                  <span > 금액 : {{ comma( cart.amount) }}</span>

              </div>

              <v-divider class="my-5"></v-divider>

              <v-select
                style="margin:0 auto  ;width: 100%;"
                class="select-wrapper"
                :items="fromWallet"
                label="결제코인"
                :placeholder="$t('swap.errCoin')"          
                v-model="fromType"
                required         
                @change="onChangeFromtype"     
              >
              <!-- @change="onChangeFromtype" -->
                <template slot="selection" slot-scope="{ item }">
                  <div class="d-flex select-item justify-space-between px-4">
                    <div class="d-flex align-center justify-center">
                
                      <div class="font-weight-black d-flex align-center">
                        {{ item.name }}
                      </div>
                    </div>
                    <!-- 
                      <div class="font-weight-medium d-flex align-center justify-end">
                     {{ comma(item.balance) }} 
                    </div> 
                  -->
                  </div>
                </template>

                <template slot="item" slot-scope="{ item }">
                  <div class="d-flex select-item justify-space-between">
                    <div class="d-flex align-center justify-center">
                      <!-- <img
                        class="mr-2"
                        style="width:1.5rem;"
                        :src="require(`@/assets/svg/${item.name}-logo.svg`)"
                      /> -->
                      <div class="font-weight-black d-flex align-center">
                        {{ item.name }}
                      </div>
                    </div>
                    <!-- <div class="font-weight-medium d-flex align-center justify-end">
                      {{ comma(item.balance) }}
                    </div> -->
                  </div>
                </template>
        </v-select>              
              <div class="sheet-row" style="float:right ; padding-right: 30px;;"   > 
                  <span > 합계 :  {{comma(cartTotal)}} </span>
              </div>

            </v-card-text>



          </template>          
 
     
        </v-card-text>


        <v-btn
          color="primary"
          fixed
          style="bottom:0;"
          tile
          block
          large
          height="56px"
          @click="submitPay"
          :disabled="(!is_cart && !fromType)"
        >
          결제하기
        </v-btn>
      </v-card>
    </v-bottom-sheet>
    <div style="margin-bottom:200px;width:100%;">      
        <v-btn
        style="width:100%;"
          class="font-weight-bold mb-4"
          color="primary"
          @click="confirmDialog = true"
          x-large
          block
          :disabled="is_cart"
        >
          구매하기
        </v-btn>
    </div>
 
  </v-container>
</template>

<script>
  import $ from 'jquery' ; 
  import { required, email } from 'vee-validate/dist/rules'

  import PhoneOverlay from '../components/PhoneOverlay.vue'
  import {
    extend,
    ValidationObserver,
    ValidationProvider,
    setInteractionMode
  } from 'vee-validate' 
  import VueQRCodeComponent from 'vue-qrcode-component' ;
  import VueBarcode from 'vue-barcode' ; 
  // import $ from 'jquery' ;  
 
    
  setInteractionMode('eager') 
  
  function signOut() {
    var auth2 = gapi.auth2.getAuthInstance();
    auth2.signOut().then(function () {
      console.log('User signed out.');
      });
  }


export default {
  components: {  VueQRCodeComponent, VueBarcode ,  ValidationProvider,    ValidationObserver  },
  mounted() {       
  },
  data: () => ({
    products : [
      {idx:1, name :'새우깡1' , amount:1000 ,descript : '설명1' ,pimg:'https://img.danawa.com/prod_img/500000/161/711/img/4711161_1.jpg?shrink=330:330&_v=20161130143749'}  , 
      {idx:2, name :'새우깡2' , amount:2000 ,descript : '설명2' ,pimg:'https://img.danawa.com/prod_img/500000/161/711/img/4711161_1.jpg?shrink=330:330&_v=20161130143749'}  ,
      {idx:3, name :'새우깡3' , amount:2000 ,descript : '설명3' ,pimg:'https://img.danawa.com/prod_img/500000/161/711/img/4711161_1.jpg?shrink=330:330&_v=20161130143749'}  ,
      {idx:4, name :'새우깡4' , amount:2000 ,descript : '설명4' ,pimg:'https://img.danawa.com/prod_img/500000/161/711/img/4711161_1.jpg?shrink=330:330&_v=20161130143749'}  ,

    ],  
    
    valid: true,
    cartList : [],
    cartTotal:0 ,
    phone: '',
    token: '',
    errors: '',
    confirmModal: false,
    confirmDialog:false , 
    fromType:false , 
    toType:false , 
    nowTime: new Date().getTime(),
    jsonDataTxt : null 

  }),
  computed: {
   
    fromWallet() {      
      
      return [ {name:'ETH'} ,   {name:'USDT'} ,   {name:'CCC'} ,   {name:'CCS'} ] ; 
      return this.$store.getters.wallet.filter((item) => item.balance > 0  )
      // console.log( this.$store.getters.wallet) ; 
      return this.$store.getters.wallet
    },    
    is_cart(){ 
      console.log( this.cartList.length )
      return this.cartList.length > 0 ? false : true 
    } ,
    is_login() {
      return this.$store.getters.is_login
    },
    loading() {
      return this.$store.getters.loading
    }   
  },
  
  created() { 

  },
  methods: {
    refresh() {
      this.nowTime = new Date().getTime()      
    }, 
    onChangeFromtype(){
      
      // console.log( this.fromType  )
    },
    disabled(){},
    submitPay(){

          this.refresh(); 
          let Obj = { token : this.fromType.name  , total : this.cartTotal , cart: this.cartList ,  now: this.nowTime } ; 
   
          this.$store
          .dispatch('MARKET_ACT', {
              proc : 'matket_reg' , 
              uid: 0 ,
              now: this.nowTime,
              token: this.fromType.name , 
              req_payed : Obj 
            })
          .then((response) => {
            // console.log( response )
            if (response.data.payment_id) {          

                // this.is_payed = true ; 
                // const bg = document.getElementsByClassName('bg')[0]      
                // bg.style.display = 'block' ; 
                
                this.jsonDataTxt = JSON.stringify({
                      uid: 0 ,
                      ptype:'market' , 
                      now: this.nowTime,
                      token: this.fromType.name , 
                      payment_id : response.data.payment_id 
                    })  ;   

                    this.confirmDialog = false ;
                    this.confirmModal = true ;
                    this.payment_id = response.data.payment_id ; 

            } else {  
                alert('결제정보를 다시 확인해 주세요 ') ; 
                location.reload() ; 
                return false ; 
            } ;  
          }) ; 





    },
    authCheck(){
    },
    addCard(item){
      this.cartList.push(item) ; 
      this.cartTotal += item.amount ; 
      
      this.cartTotal = 0 ; 
      this.cartList.forEach((number, index, item) => {          
         // console.log( this.cartList[index].amount )
          this.cartTotal += this.cartList[index].amount  ;
      });
      console.log("cartTotal :: " , this.cartTotal);

    } , 
    imgSrcLogo(){
      return '' ; // require(`@/assets/img/${this.wlabels.logo}` ); 
    } ,      

    parseJwt (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    }, 
  
   
    filterKo() {
      const koreanRegex = /[ㄱ-ㅎㅏ-ㅣ가-힣]/g
      return this.password.replace(koreanRegex, '')
    },
    isEmail(asValue){
      var regExp =/^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i
      return regExp.test(asValue) // 형식에 맞는 경우 true 리턴
    } , 
    isNumber(asValue){
      var regExp =/\d/
      return regExp.test(asValue) // 형식에 맞는 경우 true 리턴
    } ,  
    submit() {
      // 메일타입이 아닐경우 (핸드폰 Number Only! )
      if( this.isEmail(this.phone.trim() ) == false  ){
        if( isNaN( this.phone.trim() ) )   {
          alert( "Only numbers for your mobile phone number!" )
          return false ; 
        }
      } 
      this.$store.commit('loading', true)
      if (this.$refs.observer.validate()) {
        const params = {
          phone: this.phone.trim(),
          token: this.token.trim()
        }

        this.$store
          .dispatch('LOGIN', params)
          .then((res) => {
            if (!res) {
              throw new Error('no response')
              
            } else if (res.type === 'new') {
              this.submit()
            } else if (res.code === 'auth') {
              
              this.$store.commit('loading', false)
              this.$router.replace({
                name: 'verify',
                params: { phone: params.phone }
              })
            } else if (res.code === 'email') {
              this.$store
                .dispatch('SEND_VERIFY_CODE', {
                  email: params.email
                })
                .then((response) => {
                  this.$store.commit('loading', false)
                  if (response.data.status) {
                    this.$router.push({
                      name: 'verify',
                      params: { email: params.email }
                    })
                  }
                })
            } else if (res.code === 'invalid') {
              this.$store.commit('loading', false)
              this.alert = true
              this.errors = this.$t('login.errors')
            } else throw res
          })
          .catch((error) => {
            this.$store.commit('loading', false)
            this.alert = true
            this.errors = this.$t('errorServer')
          })
      } else {
        this.$store.commit('loading', false)
        this.alert = true
        this.errors = this.$t('login.errors')
      }
    },
    scrollTo(elem) {
      let target
      if (elem === 'password') target = this.$refs.password
      if (elem === 'email') target = this.$refs.email

      this.$vuetify.goTo(target)
    }
  }
}
</script>

<style scoped>
.cart-item span {
    width: 30%;
    display: inline-flex;
}
.cart-item span:last-child {
    text-align: right;
}

.login-container {
  padding: 4rem 2rem;
  height: 100%;
  max-width: 25rem;
  overflow: auto;
}
.links {
  display: flex;
  align-items: center;
}
.link-item {
  margin-left: 1rem;
}
.links a {
  color: #000;
}
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700;800&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  min-height: 100vh;
  background: #232427;
}

body .container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 40px 0;
}

body .container .card {
  position: relative;
  min-width: 320px;
  /* height: 440px; */
  height: 360px;
  
  box-shadow: inset 5px 5px 5px rgba(0, 0, 0, 0.2),
    inset -5px -5px 15px rgba(255, 255, 255, 0.1),
    5px 5px 15px rgba(0, 0, 0, 0.3), -5px -5px 15px rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  margin: 30px;
  transition: 0.5s;
}

/* 
body .container .card:nth-child(1) .box .content a {
  background: #2196f3;
}

body .container .card:nth-child(2) .box .content a {
  background: #e91e63;
}

body .container .card:nth-child(3) .box .content a {
  background: #23c186;
} 
*/

body .container .card .box {
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  /* background: #2a2b2f; */
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: 0.5s;
}

body .container .card .box:hover {
  /* transform: translateY(-50px); */
}

body .container .card .box:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  background: rgba(255, 255, 255, 0.03);
}

body .container .card .box .content {
  padding: 20px;
  text-align: center;
}

body .container .card .box .content h2 {
  position: absolute;
  top: -10px;
  right: 30px;
  font-size: 8rem;
  color: rgba(255, 255, 255, 0.1);
}

body .container .card .box .content h3 {
  font-size: 1.8rem;
  color: #fff;
  z-index: 1;
  transition: 0.5s;
  margin-bottom: 15px;
}

body .container .card .box .content p {
  font-size: 1rem;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.9);
  z-index: 1;
  transition: 0.5s;
}

body .container .card .box .content a {
  position: relative;
  display: inline-block;
  padding: 8px 20px;
  background: black;
  border-radius: 5px;
  text-decoration: none;
  color: white;
  margin-top: 20px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  transition: 0.5s;
}
body .container .card .box .content a:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.6);
  background: #fff;
  color: #000;
}

</style>

